import { observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';

import { FlightsIconPlacard } from 'types/shared';

export class BannersStore extends Store {
  @observable public banners: FlightsIconPlacard[];
  public isDialogEvent = false;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public setIsDialogEvent(dialogEvent: boolean) {
    this.isDialogEvent = dialogEvent;
  }
}
